export const REQUEST_ERROR = /\w+_ERROR$/g;
